import { render } from "./PublicDemandNotice.vue?vue&type=template&id=0da7df12&scoped=true"
import script from "./PublicDemandNotice.vue?vue&type=script&lang=js"
export * from "./PublicDemandNotice.vue?vue&type=script&lang=js"

import "./PublicDemandNotice.vue?vue&type=style&index=0&id=0da7df12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da7df12"]])

export default __exports__